import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const SelectWithLabel = ({className, id, inputClassName, label, disabled, name, onChange, value, values}) => {
    const classValue = classNames(
        'form-group',
        className
    );
    return(
        <div 
            className={classValue}>
            <label
                className="control-label col-xs-12" 
                htmlFor={id}>
                {label}
            </label>
            <div className={inputClassName}>
                <select
                    className="form-control"
                    disabled={disabled}
                    id={id}
                    name={name}
                    onChange={onChange}
                    value={value}>
                    {values.map(function(valueOption) {
                    return (<option
                            data-key={valueOption.id}
                            key={valueOption.name} 
                            value={valueOption.value}
                            name={valueOption.name}>
                            {valueOption.displayName}
                        </option>);
                    })}
                </select>
            </div>
        </div>
    );
};

SelectWithLabel.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    inputClassName: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        displayName: PropTypes.string
    }))
};

export default SelectWithLabel;





// WEBPACK FOOTER //
// ./src/components/base/SelectWithLabel/SelectWithLabel.js